<template>
  <div class="container mx-auto my-8 px-4 lg:px-0">

    <div class="lg:mb-8 flex flex-wrap flex-col-reverse lg:flex-row justify-between items-center">
      <search-input
        class="w-full lg:max-w-sm shadow"
        placeholder="Zoeken op bronnaam.."
        @searched="onSearched">
      </search-input>
    </div>

    <table class="w-full lg:shadow">
      <thead>
        <tr class="bg-white">
          <th scope="col" class="px-6">
            <span @click="changeOrder('name')" class="cursor-pointer hover:text-green-dark mr-1">
              Bron
            </span>
          </th>
          <th scope="col" class="px-6" colspan="2">
            <span class="cursor-pointer hover:text-green-dark mr-1">
              Wordt gebruikt voor
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="source in sources" :key="source.id" class="bg-white hover:bg-grey-lightest text-grey-darker">
          <td data-label="Bron" class="border-t border-grey-lighter px-6">
            {{ source.name }}
          </td>
          <td data-label="Correctie" class="border-t border-grey-lighter px-6">
            {{ source.wrong }}
          </td>
          <td class="lg:w-1 py-6 text-right actions border-t border-grey-lighter px-6">
            <a role="button" class="block visibles" @click="correct(source)">
              Corrigeren
            </a>
          </td>
        </tr>
          <tr v-if="sources && sources.length === 0" class="bg-white hover:bg-grey-lightest text-grey-darker px-6">
            <td class="border-t border-grey-lighter px-6 py-4" colspan="3">Geen bronnen gevonden.</td>
          </tr>
      </tbody>
    </table>

    <base-pagination
      class="mt-2"
      v-if="pagination && pagination.last_page > 1"
      :total-pages="pagination.last_page"
      :total="10"
      :current-page="pagination.current_page"
      @page-changed="pageChanged">
    </base-pagination>
  </div>
</template>

<script>
import store from '@/store';
import source from '@/store/modules/source';
import SearchInput from '@/components/inputs/Search';

if (!store.state.source) store.registerModule('source', source);

import { mapState } from 'vuex';

export default {
  name: 'sources',
  components: {
    SearchInput
  },
  created() {
    this.fetch();
  },
  computed: {
    ...mapState({
      pagination: state => state.source.pagination,
      sources: state => state.source.items,
      filters: state => state.source.filters
    })
  },
  methods: {
    onSearched(keyword) {
      if (!keyword) {
        return this.fetch();
      }

      this.searched = true;
      this.$store.dispatch('source/search', keyword);
    },
    correct(source) {
      this.$store.commit('modal/setItems', source);
      this.$store.commit('modal/show', 'CorrectionModal');
    },
    pageChanged(page) {
      this.$store.commit('source/setFilters', { key: 'page', value: page });
      this.fetch();
    },
    changeOrder(key) {
      this.$store.commit('source/setFilters', { key: 'sort', value: key });
      this.fetch();
    },
    async fetch() {
      await this.$store.dispatch('source/fetchAll');
    }
  }
};
</script>
